import { render, staticRenderFns } from "./mywebviewnowinv2.vue?vue&type=template&id=bea3c8aa&scoped=true"
import script from "./mywebviewnowinv2.vue?vue&type=script&lang=js"
export * from "./mywebviewnowinv2.vue?vue&type=script&lang=js"
import style0 from "./mywebviewnowinv2.vue?vue&type=style&index=0&id=bea3c8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea3c8aa",
  null
  
)

export default component.exports